/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_scoring_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constructor aggregation — Constructor points combine both drivers' scores as per the official rules.`)
};

const es_about_scoring_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregación de constructores — Los puntos del constructor combinan las puntuaciones de ambos pilotos según las reglas oficiales.`)
};

const de_about_scoring_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konstrukteur-Aggregation — Konstrukteurpunkte kombinieren die Ergebnisse beider Fahrer gemäß den offiziellen Regeln.`)
};

const nl_about_scoring_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constructeursaggregatie — Constructeurspunten combineren de scores van beide coureurs volgens de officiële regels.`)
};

const fr_about_scoring_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrégation des constructeurs — Les points des constructeurs combinent les scores des deux pilotes selon les règles officielles.`)
};

const it_about_scoring_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggregazione costruttori — I punti costruttore combinano i punteggi di entrambi i piloti secondo le regole ufficiali.`)
};

const pt_br2_about_scoring_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregação de construtores — Os pontos de construtores combinam as pontuações de ambos os pilotos conforme as regras oficiais.`)
};

const pt_about_scoring_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregação de construtores — Os pontos dos construtores combinam as pontuações de ambos os pilotos conforme as regras oficiais.`)
};

const ja_about_scoring_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンストラクター集計 — コンストラクターポイントは公式ルールに従い両ドライバーのスコアを合算。`)
};

const zh_about_scoring_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`车队汇总 — 车队积分按照官方规则合并两位车手的得分。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_scoring_constructor = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_scoring_constructor(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_scoring_constructor", locale)
	if (locale === "en") return en_about_scoring_constructor(inputs)
	if (locale === "es") return es_about_scoring_constructor(inputs)
	if (locale === "de") return de_about_scoring_constructor(inputs)
	if (locale === "nl") return nl_about_scoring_constructor(inputs)
	if (locale === "fr") return fr_about_scoring_constructor(inputs)
	if (locale === "it") return it_about_scoring_constructor(inputs)
	if (locale === "pt-BR") return pt_br2_about_scoring_constructor(inputs)
	if (locale === "pt") return pt_about_scoring_constructor(inputs)
	if (locale === "ja") return ja_about_scoring_constructor(inputs)
	return zh_about_scoring_constructor(inputs)
};